import React, { useState, useEffect } from "react";
// import man from '../assets/images/dashboard/profile.png';
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Button,
  TabContent,
  TabPane,
} from "reactstrap";
import { ToastContainer } from "react-toastify";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { ORIGIN, SERVER_URL } from "../config";
import { defaultHeaders } from "../service/axios-service";

const Logins = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState("jwt");
  const [togglePassword, setTogglePassword] = useState(false);

  async function login() {
    // history.push(`${process.env.PUBLIC_URL}/dashboard`);
    let item = { username, password };
    const response = await fetch(`${SERVER_URL}/v1/corporate/login`, {
      method: "POST",
      headers: {
        "content-Type": "application/json",
        Accept: "application/json",
        ...defaultHeaders,
      },
      mode: "cors",
      body: JSON.stringify(item),
    });
    if (response.status === 200) {
      let result = await response.json();
      if (result.statusCode === 200) {
        localStorage.setItem("token", result.payload.token);
        // localStorage.setItem("email", username);
        history.push(`${process.env.PUBLIC_URL}/myPerformance`);
        Swal.fire({
          icon: "success",
          title: "Successfully login",
          // text: "user id or password is incorrect",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Dear Student",
          text: "user id or password is incorrect",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Dear Student",
        text: "user id or password is incorrect",
      });
    }
  }

  const handleRegister = () => {
    window.location.href = `${process.env.PUBLIC_URL}/register`;
  };

  const handleAdmin = () => {
    window.location.href = `${process.env.PUBLIC_URL}/login`;
  };

  return (
    <>
      <Container fluid={true} className="p-0">
        <Row>
          <Col xs="12">
            <div className="login-card">
              <div>
                <div className="login-main login-tab">
                  <TabContent activeTab={selected} className="content-login">
                    <TabPane className="fade show" tabId="jwt">
                      <Form className="theme-form">
                        <h4>Sign In</h4>
                        <p>{"Enter your email & password to login"}</p>
                        <FormGroup>
                          <Label className="col-form-label">User Id</Label>
                          <Input
                            className="form-control"
                            type="text"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Please enter a User Id",
                              },
                              pattern: {
                                value: "^[A-Za-z0-9]+$",
                                errorMessage:
                                  "Your User Id must be composed only with letter and numbers",
                              },
                              minLength: {
                                value: 6,
                                errorMessage:
                                  "Your User Id must be between 6 and 16 characters",
                              },
                              maxLength: {
                                value: 16,
                                errorMessage:
                                  "Your User Id must be between 6 and 16 characters",
                              },
                            }}
                            autocomplete="off"
                            onChange={(e) => setUsername(e.target.value)}
                            defaultValue={username}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label className="col-form-label">Password</Label>
                          <Input
                            className="form-control"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Please enter a Password",
                              },
                              pattern: {
                                value: "^[A-Za-z0-9]+$",
                                errorMessage:
                                  "Your Password must be composed only with letter and numbers",
                              },
                              minLength: {
                                value: 6,
                                errorMessage:
                                  "Your Password must be between 6 and 20 characters",
                              },
                              maxLength: {
                                value: 20,
                                errorMessage:
                                  "Your Password must be between 6 and 20 characters",
                              },
                            }}
                            autocomplete="off"
                            type={togglePassword ? "text" : "password"}
                            onChange={(e) => setPassword(e.target.value)}
                            defaultValue={password}
                          />
                          <div
                            className="show-hide"
                            onClick={() => setTogglePassword(!togglePassword)}
                          >
                            <span
                              className={togglePassword ? "" : "show"}
                            ></span>
                          </div>
                        </FormGroup>
                        <div className="form-group mb-0">
                          <div className="checkbox ml-3">
                            <Input id="checkbox1" type="checkbox" />
                            <Label className="text-muted" for="checkbox1">
                              RememberPassword
                            </Label>
                          </div>

                          <Button
                            color="primary"
                            className="btn-block"
                            onClick={login}
                          >
                            Sig
                          </Button>
                        </div>
                        <p
                          className="mt-4 mb-0"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <a
                            className="ml-2 onHoverRegister"
                            onClick={handleRegister}
                          >
                            {" "}
                            {"Don't have account?"}
                          </a>
                          <a
                            className="ml-2 onHoverRegister"
                            onClick={handleAdmin}
                          >
                            {" "}
                            {"Login as Admin"}
                          </a>
                        </p>
                      </Form>
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <ToastContainer />
      </Container>
    </>
  );
};

export default withRouter(Logins);
